import { render, staticRenderFns } from "./pendingList.vue?vue&type=template&id=f8925f82&scoped=true&"
import script from "./pendingList.vue?vue&type=script&lang=js&"
export * from "./pendingList.vue?vue&type=script&lang=js&"
import style0 from "./pendingList.vue?vue&type=style&index=0&id=f8925f82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8925f82",
  null
  
)

export default component.exports